import { Paper, Box, Divider, Button } from '@material-ui/core';
import React from 'react';
import AppointmentCard from './appointmentCard';
import DoctariSpinner from '../../components/Spinner';
import { connect } from 'react-redux';
import { appointmentActionsTypes } from '../../redux/appointment/actions';

const MyAppointments = ({
  appointmentData,
  theme,
  isProfessional,
  classes,
  session,
  getNewAccessToken,
  userState,
  getMpPreference,
  rapidQueueTakePatient,
}) => {
  const noRapidPatients = () => {
    for (let key in appointmentData.rapidQueues) {
      if (appointmentData.rapidQueues[key].patients.length > 0) {
        return false;
      }
    }
    return true;
  };
  console.log(noRapidPatients());

  return (
    <Paper className={classes.doctorAppointments} elevation={4}>
      {/* //TODO check appointmentData.loading and show the spinner, we need to have
      more than one loading (schedule, scheduleRequest and appointment) */}
      {userState?.user?.on_guard && (
        <>
          <h1
            className={classes.title}
            style={{ fontSize: '33px', marginBottom: 0 }}
          >
            Atención inmediata
          </h1>
          {appointmentData.loading ? (
            <DoctariSpinner />
          ) : (
            <>
              {Object.keys(appointmentData.rapidQueues || {}).length > 0 ||
              noRapidPatients ? (
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                  {Object.keys(appointmentData.rapidQueues).map(
                    (key) =>
                      appointmentData.rapidQueues[key].patients.length > 0 && (
                        <Box sx={{ margin: '1em' }}>
                          <Paper>
                            <Box
                              sx={{
                                padding: '1em',
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <h4 style={{ textAlign: 'center' }}>
                                {
                                  appointmentData.rapidQueues[key]
                                    .specialty_name
                                }
                              </h4>
                              <p
                                style={{
                                  marginTop: -15,
                                  textAlign: 'center',
                                }}
                              >
                                Pacientes en espera:{' '}
                                <b>
                                  {
                                    appointmentData.rapidQueues[key].patients
                                      .length
                                  }
                                </b>
                              </p>
                              <Divider />
                              <p>
                                <b>Próximo paciente:</b>{' '}
                                {
                                  appointmentData.rapidQueues[key]
                                    ?.patients?.[0][2]
                                }
                              </p>
                              <p style={{ marginTop: -8 }}>
                                <b>Motivo de consulta:</b>{' '}
                                {
                                  appointmentData.rapidQueues[key]
                                    ?.patients?.[0][3]
                                }
                              </p>
                              <Box
                                sx={{
                                  marginTop: 15,
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <Button
                                  variant='contained'
                                  color='primary'
                                  onClick={() => {
                                    rapidQueueTakePatient(key);
                                    // wait 1 second to reload the page
                                    // TODO remove this and use the redux state to update the page
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 1000);
                                  }}
                                >
                                  Atender
                                </Button>
                              </Box>
                            </Box>
                          </Paper>
                        </Box>
                      )
                  )}
                </Box>
              ) : (
                <p style={{ fontWeight: 300 }}>No hay pacientes para atender</p>
              )}
            </>
          )}
        </>
      )}
      <>
        <h1
          className={classes.title}
          style={{ fontSize: '33px', marginBottom: 0 }}
        >
          Mis consultas
        </h1>
        {appointmentData.loading ? (
          <DoctariSpinner />
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                padding:
                  appointmentData.appointments &&
                  appointmentData.appointments.length > 0
                    ? '3rem'
                    : '0',
              }}
            >
              {appointmentData.appointments &&
                appointmentData.appointments.length > 0 &&
                appointmentData.appointments.map((appointment) => (
                  <AppointmentCard
                    key={appointment.id}
                    appointment={appointment}
                    isProfessional={isProfessional}
                    theme={theme}
                    session={session}
                    getNewAccessToken={getNewAccessToken}
                    userState={userState}
                    appointmentData={appointmentData}
                    getMpPreference={getMpPreference}
                  />
                ))}
            </div>
            {appointmentData.appointments &&
              appointmentData.appointments.length == 0 && (
                <p style={{ fontWeight: 300 }}>No hay consultas agendadas</p>
              )}
          </>
        )}
      </>
    </Paper>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    rapidQueueTakePatient: (specialty) =>
      dispatch({
        type: appointmentActionsTypes.RAPID_QUEUE_TAKE_PATIENT,
        payload: { specialty },
      }),
  };
};

export default connect(null, mapDispatchToProps)(MyAppointments);
